import {createMuiTheme} from '@material-ui/core/styles';
import muiTheme from './theme';

export const createDarkMuiTheme = () => {
  return createMuiTheme({...muiTheme, palette: {...muiTheme.palette, ...muiTheme.darkPalette, type: 'dark'}});
};
